import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ProductCreateDto, ProductStatus } from 'src/app/model/product';
import { MessageService } from 'src/app/service/message.service';
import { ProductService } from 'src/app/service/product.service';
import { getHostProductEditUrl } from 'src/app/util/host-product-urls';

@Component({
  selector: 'meeting-add',
  templateUrl: './meeting-add.page.html',
  styleUrls: ['./meeting-add.page.scss'],
})
export class MeetingAddPage implements OnInit {
  constructor(
    private router: Router,
    private productService: ProductService,
    private messageService: MessageService,
  ) {}

  ngOnInit() {
    // Create empty product immediately and redirect to edit page
    this.createEmptyProductAndRedirect();
  }

  private createEmptyProductAndRedirect() {
    // Create minimal DTO with required fields only
    const emptyDto = new ProductCreateDto(
      2, // version
      '', // title - empty string
      '', // recommend - empty string
      '', // address - empty string
      '', // detailAddress - empty string
      '', // howToCome - empty string
      0, // runningDays
      0, // runningHours - default 0 for host products
      0, // runningMinutes
      24, // reservationHours - default 24
      0, // lat
      0, // lon
      '', // country
      '', // sido
      '', // sigugun
      '', // dongmyun
      '', // ri
      '', // rest
      0, // price
      null, // discountPrice
      '', // notice - empty string
      '', // checkList - empty string
      '', // includeList - empty string
      '', // excludeList - empty string
      '', // refundPolicy - empty string
      ProductStatus.DISABLED, // status - disabled by default
      true, // isBusiness - true for host products
      true, // isOffline
      [], // hashtags - empty array
      [], // representationPhotos - empty array
      '#f5f5f5', // color - default color
      '', // point - empty string for version 2
      '', // description - empty string
      [], // summaries - empty array for version 2
      [], // sections - empty array for version 2
      [], // amenities - empty array
      [], // courses - empty array
      undefined, // onlineMethod
    );

    // Create the product and redirect to edit page
    this.productService.addProduct(emptyDto).subscribe(
      (product) => {
        console.log('Product created successfully:', product);
        // 위저드는 Next.js(`webDomain`)에서 호스팅한다. RC가 OFF이면 Next.js
        // 페이지가 다시 host.nonunbub.com의 Angular legacy로 redirect한다.
        window.location.href = getHostProductEditUrl(product.id);
      },
      (error) => {
        console.error('Product creation error:', error);
        this.messageService.popup({
          title: '상품 생성 오류',
          description: '상품 생성에 실패했습니다. 다시 시도해주세요.',
          cancelLabel: '확인',
          cancelHandler: () => {
            this.router.navigate(['/host/products']);
          },
        });
      },
    );
  }
}
